import { ITournament } from '@/mainComponent/store/interfaces/newInterfaces/ITournament';
import { Validator } from '@/utils/ajv/ajv';
import { Utils } from '@/utils/Utils';
import { tournamentPlayers } from '@/mainComponent/store/interfaces/newInterfaces/types';
import { ACTION } from '@/store/ACTION';
import { IPrizeSpins } from '@/mainComponent/store/interfaces/newInterfaces/IPrizeSpins';
import { PromoComponent } from '@/mainComponent/PromoComponent';
import { IPayment } from '@/mainComponent/store/interfaces/newInterfaces/IPayment';

class SetTournaments {
  protected isSendZero: boolean = false;

  tournament: any = {};
  oldTournament: any = {
    id: 0,
    name: '',
    stage: '',
    startedAt: '',
    finishedAt: '',
    closedAt: '',
    rules: {
      autoCharging: false,
      currencyCode: '',
      currencyDecimals: 0,
      games: [],
      minBet: 0,
      minRounds: 0,
      prizes: [],
      roundPoints: 0,
      winPoints: 0,
      winToBetPoints: 0,
      betPoints: 0
    }
  };

  freeRounds: any = {};
  oldFreeRounds: any = {
    betOption: 0,
    denomination: 1,
    lines: 1,
    id: 0,
    reward: {
      granted: true,
      gid: 1001,
      rounds: 0,
      roundsLeft: 0,
      gameName: '',
      wins: 0
    },
    tournament: true
  };
  setTournament(tournament: ITournament): void {
    Validator.validate('tournament', tournament);
    Utils.parse.call(this, this.tournament, tournament);
    this.transformTournament();
  }

  setPlayers(data: { players: tournamentPlayers, conditions?: { minRounds: number}, progress?: { rounds: number} }) {
    //@ts-ignore
    game.store.promo.tournamentPlayers = data.players;
    promoApp.eventEmitter.emit(ACTION.SET_TOURNAMENT_PLAYERS_DATA, data);
  }

  setPrize(prize: IPrizeSpins | IPayment) {
    if (prize.type === 'payment') {
      game.emit(PromoComponent.events.SET_WAGER, { id: prize.id, type: 'tournament' });
      game.store.promo.wagerData = prize;
      return;
    }

    Utils.parse.call(this, this.freeRounds, prize);
    this.transformFreeRounds();
  }

  setRequirements(data: { sendZero: boolean }): void {
    this.isSendZero = data.sendZero;
  }

  sendTournamentData() {
    game.store.promo.setData({ tournament: this.oldTournament });
  }
  sendPrizeData() {
    game.store.promo.setData({ achievement: this.oldFreeRounds });
    if (game.store.promo.isValidTournamentFreeRoundsGame()) game.emit(PromoComponent.events.SET_WAGER);
  }

  deleteTournament() {
    game.store.promo.resetTournament();
    this.sendTournamentData();
  }

  transformFreeRounds(): void {
    this.oldFreeRounds.betOption = this.freeRounds.bet;
    this.oldFreeRounds.reward.gid = this.freeRounds.games[0].id;
    this.oldFreeRounds.reward.rounds = this.freeRounds.rounds;
    this.oldFreeRounds.reward.roundsLeft = this.freeRounds.roundsLeft;
    this.oldFreeRounds.reward.gameName = this.freeRounds.games[0].name;
    this.oldFreeRounds.reward.wins = this.freeRounds.wins;
    this.oldFreeRounds.id = this.freeRounds.id;
    this.sendPrizeData();
  }

  transformTournament(): void {
    this.oldTournament.id = this.tournament.id;
    this.oldTournament.name = 'test';
    this.oldTournament.stage = this.tournament.info.status === 'results' ? 'finished' : this.tournament.info.status;
    this.oldTournament.startedAt = this.tournament.time.startedAt;
    this.oldTournament.finishedAt = this.tournament.time.resultedAt;
    this.oldTournament.closedAt = this.tournament.time.finishedAt;
    this.oldTournament.rules.autoCharging = this.tournament.autoCharging;
    this.oldTournament.rules.currencyCode = this.tournament.currency.code;
    this.oldTournament.rules.currencyDecimals = this.tournament.currency.decimals;
    this.oldTournament.rules.games = this.tournament.participatingGames;
    this.oldTournament.rules.minBet = this.tournament.conditions.minBet;
    this.oldTournament.rules.minRounds = this.tournament.conditions.minRounds;
    this.oldTournament.rules.prizes = (<ITournament>this.tournament).info.prizes.map(newPrize => {
      const freeRoundPrize = newPrize.prize.find(prize => prize.type === 'freeRounds');
      const PaymentPrize = newPrize.prize.find(prize => prize.type === 'payment');
      return {
        to: newPrize.to,
        amountFS: freeRoundPrize?.amount || 0,
        // @ts-ignore
        amountFSGameName: freeRoundPrize ? freeRoundPrize.games[0].name : '',
        from: newPrize.from,
        amount: PaymentPrize?.amount || 0
      };
    });
    this.oldTournament.rules.roundPoints = this.tournament.info.points.round;
    this.oldTournament.rules.winPoints = this.tournament.info.points.win;
    this.oldTournament.rules.winToBetPoints = this.tournament.info.points.winToBet;
    this.oldTournament.rules.betPoints = this.tournament.info.points.bet;
    this.sendTournamentData();
  }
}

export { SetTournaments };
